import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import TableSortLabel from "@mui/material/TableSortLabel";
const useStyles = makeStyles(theme => ({
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const SortLabel = ({ state, property, handleRequestSort, label }) => {
  const classes = useStyles();
  return (
    <TableSortLabel
      active={state.orderBy === property}
      direction={state.orderDirection}
      onClick={() => handleRequestSort(property)}
    >
      {label}
      {state.orderBy === property ? (
        <span className={classes.visuallyHidden}>
          {state.orderDirection === "desc"
            ? "sorted descending"
            : "sorted ascending"}
        </span>
      ) : null}
    </TableSortLabel>
  );
};

export default SortLabel;
